import Aupload from '@/components/Aupload/Icon';

export default {
  name: 'BformItem',
  components: {
    Aupload,
  },
  props: {
    config: { type: Object, default: () => ({}) },
    optionApi: { type: String, default: () => '' },
  },
  data() {
    return {
      rand: 0,
      dicts: [],
      option: [],
    }
  },
  watch: {
    config: {
      immediate: true,
      handler() {
        this.create();
      },
    }
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      this.rand = Math.random();
      const { dicts, field } = this.config;
      if (dicts && dicts.length > 0) {
        for (let a in dicts) {
          if (dicts[a].type == field) {
            this.dicts.push({ label: dicts[a].name, value: dicts[a].code, ...dicts[a] });
          }
        }
      }
      return this.dicts;
    },
    filter(form) {
      const data = {};
      for (let a in form) {
        if (a != undefined && a != 'undefined' && form[a] != '' && form[a] != '%%' && form[a] != 'undefined' && form[a] != null && form[a] != undefined) data[a] = form[a];
      }
      return data;
    },
    format({ form, text, label, title, field, dicts, table, ...props }) {
      const words = text || label || title;
      if (!props.type) return <el-input v-model={form[field]} on-change={props.change ? e => props.change(e) : () => false} placeholder={`请输入${words}`} style={{ ...props.style }} {...{ props }} />
      if (table && (props.type == 'year' || props.type == 'month' || props.type == 'date' || props.type == 'time')) {
        return <el-input v-model={form[field]} on-change={props.change ? e => props.change(e) : () => false} placeholder={`请输入${words}`} style={{ ...props.style }} {...{ props }} />
      }
      switch (props.type) {
        case 'input': return <el-input v-model={form[field]} on-change={props.change ? e => props.change(e) : () => false} placeholder={`请输入${words}`} style={{ ...props.style }} {...{ props }} />
        case 'password': return <el-input v-model={form[field]} on-change={props.change ? e => props.change(e) : () => false} placeholder={`请输入${words}`} style={{ ...props.style }} show-password {...{ props }} />
        case 'enuma': return (
          <el-select clearable filterable v-model={form[field]} on-change={props.change ? e => props.change(e) : () => false} placeholder={`请选择${words}`} style={{ ...props.style }} {...{ props }}>
            {this.option && this.option.length > 0 && this.option.map((a, b) => <el-option key={b} label={a.label || a.title || a.name || a.text} value={(a.value || a.code || a.id)} />)}
          </el-select>
        );
        case 'enumerate': return (
          <el-select clearable filterable v-model={form[field]} on-change={props.change ? e => props.change(e) : () => false} placeholder={`请选择${words}`} style={{ ...props.style }} {...{ props }}>
            {this.option && this.option.length > 0 && this.option.map((a, b) => <el-option key={b} label={a.label || a.title || a.name || a.text} value={(a.value || a.code || a.id)} />)}
          </el-select>
        );
        case 'select': return (
          <el-select clearable filterable v-model={form[field]} on-change={props.change ? e => props.change(e) : () => false} placeholder={`请选择${words}`} style={{ ...props.style }} {...{ props }}>
            {props.data && props.data.length > 0 ?
              (props.data.map((a, b) => <el-option key={b} label={a.label || a.title || a.name || a.text} value={(a.value || a.code || a.id)} />))
              :
              (this.dicts.map((a, b) => <el-option key={b} label={a.label || a.title || a.name || a.text} value={(a.value || a.code || a.id)} />))
            }
          </el-select>
        );
        case 'checkbox': return (<el-checkbox v-model={form[field]} on-change={props.change ? e => props.change(e) : () => false} style={{ ...props.style }} {...{ props }}>{words}</el-checkbox>);
        case 'checkboxGroup': return (
          <el-checkbox-group v-model={form[field]} on-change={props.change ? e => props.change(e) : () => false} style={{ ...props.style }} {...{ props }}>
            {props.data && props.data.length > 0 ?
              (props.data.map((a, b) => <el-checkbox key={b} label={a.value || a.code || a.id}>{a.label || a.title || a.text}</el-checkbox>))
              :
              (this.dicts.map((a, b) => <el-checkbox key={b} label={a.value || a.code || a.id}>{a.label || a.title || a.text}</el-checkbox>))
            }
          </el-checkbox-group>
        );
        case 'radio': return (
          <el-radio-group v-model={form[field]} on-change={props.change ? e => props.change(e) : () => false} style={{ ...props.style }} {...{ props }}>
            {props.data && props.data.length > 0 ?
              (props.data.map((a, b) => <el-radio key={b} label={a.value || a.code || a.id}>{a.label || a.title || a.text}</el-radio>))
              :
              (this.dicts.map((a, b) => <el-radio key={b} label={a.value || a.code || a.id}>{a.label || a.title || a.text}</el-radio>))
            }
          </el-radio-group>
        );
        case 'switch': return <el-switch v-model={form[field]} on-change={props.change ? e => props.change(e) : () => false} active-value="1" inactive-value={"0" || null} active-text="启用" inactive-text="禁用" active-color="#13ce66" style={{ ...props.style }} {...{ props }} />
        case 'date': return <el-date-picker v-model={form[field]} type={props.type} on-change={props.change ? e => props.change(e) : () => false} placeholder={`请选择${words}`} style={{ width: props.width, ...props.style }} {...{ props }} />
        case 'time': return <el-time-picker v-model={form[field]} type={props.type} on-change={props.change ? e => props.change(e) : () => false} placeholder={`请选择${words}`} style={{ width: props.width, ...props.style }} {...{ props }} />
        case 'year': return <el-date-picker type="year" v-model={form[field]} on-change={props.change ? e => props.change(e) : () => false} placeholder={`请选择${text}`} style={{ width: props.width, ...props.style }} {...{ props }} />
        case 'month': return <el-date-picker type="month" v-model={form[field]} on-change={props.change ? e => props.change(e) : () => false} placeholder={`请选择${text}`} style={{ width: props.width, ...props.style }} {...{ props }} />
        case 'color': return <el-color-picker v-model={form[field]} size={this.size} on-change={props.change ? e => props.change(e) : () => false} placeholder={`请选择${text}`} style={{ width: props.width, ...props.style }} {...{ props }} />
        case 'image': return <Aupload key={this.rand} v-model={form[field]} src={form[field]} on-change={props.change ? e => props.change(e) : () => false} placeholder={`请选择${words}`} style={{ ...props.style }} {...{ props }} />
        // case 'editor': return <Aeditor v-model={form[field]} on-change={props.change ? e => props.change(e) : () => false} placeholder={`请输入${words}`} style={{ ...props.style }} {...{ props }} />
        case 'custom': return props.render(this.filter(form), props);
        default: return <el-input v-model={form[field]} on-change={props.change ? e => props.change(e) : () => false} placeholder={`请输入${words}`} style={{ ...props.style }} {...{ props }} />
      }
    }
  },
  render() {
    return this.format(this.config);
  }
}